<template>
  <div>

    <div class="section0">

      <b-container class="px-4 py-5">
        <b-row>

          <b-col md="6" sm="12">
            <h1 class="display-5 fw-bold lh-1 mb-3">Handmade, lightning fast websites for your small business</h1>

            <p class="lead">Don't hassle with site building tools that give you slow and unoriginal results. We will
              work with you to
              design a website that fits your business needs and outperforms the competition.</p>
            <b-button class="mt-4">GET STARTED</b-button>
          </b-col>

          <b-col class="responsive-devices my-auto">
            <img src="@/assets/responsive-devices.png" class="d-block w-100">
          </b-col>

        </b-row>
      </b-container>

    </div>

    <div class="section1">
      <b-container class="px-4 py-5">

        <b-row class="g-5">

          <b-col sm="12" md="4" data-aos="fade-up" data-aos-delay="0">
            <img class="d-block mx-auto" src="@/assets/scissors-icon.png">
            <h1 class="display-5 fw-bold lh-1 mt-3 mb-3 text-center">Bespoke designs, tailored to your business</h1>

            <p class="lead">Don't hassle with site building tools that give you slow and unoriginal results. We will
              work with you to
              design a website that fits your business needs and outperforms the competition.
            </p>
          </b-col>

          <b-col sm="12" md="4" data-aos="fade-up" data-aos-delay="50">

            <img class="d-block mx-auto" src="@/assets/savings-icon.png">
            <h1 class="display-5 fw-bold lh-1 mt-3 mb-3 text-center">No upfront costs, pay only for what you need</h1>

            <p class="lead">With no upfront costs, our plans are perfect for accelerating your small business's growth.
              Pay for what you need and add features and design
              updates as you need them.</p>
          </b-col>

          <b-col sm="12" md="4" data-aos="fade-up" data-aos-delay="100">
            <img class="d-block mx-auto" src="@/assets/hosting-icon.png">
            <h1 class="display-5 fw-bold lh-1 mt-3 mb-3 text-center">Hosting and continuous updates included</h1>

            <p class="lead">Web hosting and maintenance is included at no additional cost. Unlimited updates to website
              design included with 24/7 support.</p>
          </b-col>

        </b-row>

        <!-- <img id="semi-circle" src="@/assets/semi-circle.svg" right="0px" height="150px" /> -->

      </b-container>

    </div>

    <section class="timeline">
      <b-container class="py-5">

        <div class="timeline-item">
          <div class="timeline-img"></div>

          <div class="timeline-content" :data-aos="timelineAnimation">
            <h2>Title</h2>
            <!-- <div class="date">1 MAY 2016</div>  -->
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime ipsa ratione omnis alias cupiditate
              saepe atque totam aperiam sed nulla voluptatem recusandae dolor, nostrum excepturi amet in dolores. Alias,
              ullam.</p>

            <a class="bnt-more" href="javascript:void(0)">More</a>
          </div>
        </div>

        <div class="timeline-item">

          <div class="timeline-img"></div>

          <div class="timeline-content timeline-card" :data-aos="timelineAnimationAlternate">
            <div class="timeline-img-header">
              <h2>Card Title</h2>
            </div>
            <!-- <div class="date">25 MAY 2016</div> -->
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime ipsa ratione omnis alias cupiditate
              saepe atque totam aperiam sed nulla voluptatem recusandae dolor, nostrum excepturi amet in dolores. Alias,
              ullam.</p>
            <a class="bnt-more" href="javascript:void(0)">More</a>
          </div>

        </div>

        <div class="timeline-item">

          <div class="timeline-img"></div>

          <div class="timeline-content" :data-aos="timelineAnimation">
            <!-- <div class="date">3 JUN 2016</div> -->
            <h2>Quote</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dicta explicabo debitis omnis dolor
              iste fugit totam quasi inventore!</p>
          </div>
        </div>

        <div class="timeline-item">

          <div class="timeline-img"></div>

          <div class="timeline-content" :data-aos="timelineAnimationAlternate">
            <h2>Title</h2>
            <!-- <div class="date">22 JUN 2016</div> -->
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime ipsa ratione omnis alias cupiditate
              saepe atque totam aperiam sed nulla voluptatem recusandae dolor, nostrum excepturi amet in dolores. Alias,
              ullam.</p>
            <a class="bnt-more" href="javascript:void(0)">More</a>
          </div>
        </div>

        <div class="timeline-item">

          <div class="timeline-img"></div>

          <div class="timeline-content timeline-card" :data-aos="timelineAnimation">
            <div class="timeline-img-header">
              <h2>Card Title</h2>
            </div>
            <!-- <div class="date">10 JULY 2016</div> -->
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime ipsa ratione omnis alias cupiditate
              saepe atque totam aperiam sed nulla voluptatem recusandae dolor, nostrum excepturi amet in dolores. Alias,
              ullam.</p>
            <a class="bnt-more" href="javascript:void(0)">More</a>
          </div>
        </div>

        <div class="timeline-item">

          <div class="timeline-img"></div>

          <div class="timeline-content timeline-card" :data-aos="timelineAnimationAlternate">
            <div class="timeline-img-header">
              <h2>Card Title</h2>
            </div>
            <!-- <div class="date">30 JULY 2016</div> -->
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime ipsa ratione omnis alias cupiditate
              saepe atque totam aperiam sed nulla voluptatem recusandae dolor, nostrum excepturi amet in dolores. Alias,
              ullam.</p>
            <a class="bnt-more" href="javascript:void(0)">More</a>
          </div>
        </div>

        <div class="timeline-item">

          <div class="timeline-img"></div>

          <div class="timeline-content" :data-aos="timelineAnimation">
            <!-- <div class="date">5 AUG 2016</div> -->
            <h2>Quote</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dicta explicabo debitis omnis dolor
              iste fugit totam quasi inventore!</p>
          </div>
        </div>

      </b-container>
    </section>


  </div>

</template>

<script>
export default {
  name: "App",
  mounted: function () {

    document.addEventListener("DOMContentLoaded", function () 
    {
      var lazyBackgrounds = [].slice.call(document.querySelectorAll(".timeline-img-header"));

      if ("IntersectionObserver" in window) {
        let lazyBackgroundObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
              lazyBackgroundObserver.unobserve(entry.target);
            }
          });
        });

        lazyBackgrounds.forEach(function (lazyBackground) {
          lazyBackgroundObserver.observe(lazyBackground);
        });
      }
    });

    // window.onscroll = function () {

    //   scrollRotate();
    // };

    // function scrollRotate() {
    //   let image = document.getElementById("semi-circle");
    //   image.style.transform = "rotate(" + window.pageYOffset / 2 + "deg)";
    // }
  },

  computed: {
    timelineAnimation() {
      if (window.matchMedia('(max-width: 768px)').matches) {
        return this.timelineAnimationAlternate;
      }

      return "fade-right"
    },
    timelineAnimationAlternate() {
      return "fade-left"
    }
  }
};
</script>

<style src=".\Home.css">
</style>  